/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightUp: {
  name: 'arrow-right-up';
  data: string;
} = {
  name: 'arrow-right-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1A.5.5 0 0 1 4 .5h11a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0V2.207L1.354 15.354a.5.5 0 0 1-.708-.708L13.793 1.5H4a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
